import { render, staticRenderFns } from "./IconSpeedioExclent.vue?vue&type=template&id=0ef3142c&"
import script from "./IconSpeedioExclent.vue?vue&type=script&lang=ts&"
export * from "./IconSpeedioExclent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports